import React, { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import LoadingButton from '@mui/lab/LoadingButton';
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmDialog from './confirm.dialog';

import GoogleSheetsService from '../service/googlesheet.service';

const PlayerSummerTourForm = ({ disableName, disableGolfId, updatePlayer, player, enableCancel, competitionId, updateValidation }) => {
    const [cancelling, setCancelling] = useState(false);
    const [confirmCancelOpen, setConfirmCancelOpen] = useState(false);

    const cancelRegistration = () => {
        setConfirmCancelOpen(false);
        setCancelling(true);
        GoogleSheetsService.cancelRegistration(2, competitionId, player.registrationNumber, player.name).then((success) => {
            setCancelling(false);
            if (success === true) {
                updatePlayer({ ...player, status: 4 });
                updateValidation(`${player.name} är nu avbokad från tävlingen!`, '');
            } else {
                updateValidation('', 'Tävlingen börjar snart! Du kan tyvärr inte längre avboka eller ändra på din bokning');
            }
        });
    }

    return (
        <div className='s4g-section'>
            <div className='s4g-player-form'>
                <div className='s4g-player-form-input-100'>
                    <div className='s4g-control-40'>
                        <div className='s4g-player-name-info'>
                            {enableCancel === true && <div className='pr-3'>
                                <LoadingButton
                                    loading={cancelling}
                                    variant="outlined"
                                    loadingPosition="start"
                                    startIcon={<CancelIcon />}
                                    onClick={() => setConfirmCancelOpen(true)}>
                                    Avboka
                                </LoadingButton>
                            </div>}
                            {player.alreadyRegistered === false && <TextField required={!disableName} id="s4g-p-name" label="Namn" sx={{ width: '100%;' }} disabled={disableName}
                                value={player.name || ''} onChange={e => updatePlayer({ ...player, name: e.target.value })} />}
                            {player.alreadyRegistered === true && <p className='s4g-summer-already-reg'><strong>{player.golfId} är redan registrerad</strong></p>}
                        </div>
                    </div>
                    <div className='s4g-control-20'>
                        <TextField required id="s4g-p-golfid" label="Golfid" sx={{ width: '100%;' }} disabled={disableGolfId}
                            value={player.golfId || ''} onChange={e => updatePlayer({ ...player, golfId: e.target.value })} />
                    </div>
                    <div className='s4g-control-20'>
                        <FormControl sx={{ width: '100%;' }}>
                            <InputLabel id="s4g-p-tee-type-label">Tee *</InputLabel>
                            <Select labelId="s4g-p-tee-type-label" id="s4g-tee-type-select" value={player.teeType} label="Tee *"
                                onChange={e => updatePlayer({ ...player, teeType: e.target.value })} >
                                <MenuItem value='' disabled>Välj tee...</MenuItem>
                                <MenuItem value='Herre gul tee'>Herre gul tee</MenuItem>
                                <MenuItem value='Herre röd tee'>Herre röd tee (över 70 år)</MenuItem>
                                <MenuItem value='Dam röd tee'>Dam röd tee</MenuItem>
                            </Select>
                        </FormControl>
                    </div>

                    <div className='s4g-control-20'>
                        <FormControl sx={{ width: '100%;' }}>
                            <InputLabel id="s4g-p-dinner-label">Middag? *</InputLabel>
                            <Select labelId="s4g-p-dinner-label" id="s4g-dinner-select" value={player.dinnerOption} label="Middag? *"
                                onChange={e => updatePlayer({ ...player, dinnerOption: e.target.value })} >
                                <MenuItem value='' disabled>Välj ja/nej...</MenuItem>
                                <MenuItem value='1'>Ja</MenuItem>
                                <MenuItem value='2'>Nej</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
            </div>
            <ConfirmDialog
                open={confirmCancelOpen}
                name={player.name}
                confirm={() => cancelRegistration()}
                close={() => setConfirmCancelOpen(false)}
            />
        </div>
    );
}

export default PlayerSummerTourForm;
